export default "__VITE_ASSET__HdolM6$t__"